@let corpDesign = corporateDesign();
@if (isToggleVisible() && corpDesign) {
  @let isSubscription = currentTicketType() === TicketType.Subscription;
  @let isDirectTicket = currentTicketType() === TicketType.Direct;
  <div class="flex h-full flex-row items-center text-sm">
    <div
      class="box-border flex flex-row rounded-md text-base"
      [ngClass]="{
        'border-standard-outline-medium border-1':
          !corporateDesignService.isDarkModeActive(),
      }"
      [style.border-radius]="corporateDesignService.borderRadius()"
      [style.border-color]="corpDesign.primaryBorderColor">
      <button
        type="button"
        class="cursor-pointer rounded-md px-3 py-1"
        [attr.data-testid]="
          'show-subscription-tickets' | appendTestId: 'button'
        "
        (click)="selectSubscription()"
        (keydown.enter)="selectSubscription()"
        [ngStyle]="{
          borderRadius: corporateDesignService.borderRadius(),
          color: isSubscription
            ? corporateDesignService.primaryFontColor()
            : '',
          backgroundColor: determineBackgroundColor(TicketType.Subscription),
        }"
        [ngClass]="{
          '-m-[1px]': isSubscription,
        }">
        {{
          textStore.texts()
            | filterTexts: ERelationType.aboToggle : EEntityType.generic
            | language
        }}
      </button>
      <button
        type="button"
        class="cursor-pointer rounded-md px-3 py-1"
        (click)="selectDirect()"
        (keydown.enter)="selectDirect()"
        [attr.data-testid]="'show-direct-tickets' | appendTestId: 'button'"
        [ngStyle]="{
          color: isDirectTicket
            ? corporateDesignService.primaryFontColor()
            : '',
          borderRadius: corporateDesignService.borderRadius(),
          backgroundColor: determineBackgroundColor(TicketType.Direct),
        }"
        [ngClass]="{
          '-m-[1px]': !isSubscription,
        }">
        {{
          textStore.texts()
            | filterTexts: ERelationType.directToggle : EEntityType.generic
            | language
        }}
      </button>
    </div>
  </div>
}
